export default {
  zh: {
    rule: '规则',
    recharge: '充值',
    glory: '财富',
    charm: '魅力',
    room: '房间',
    rw: '奖励',
    medalDesc: '多次获得勋章，勋章将会升级',
    winer: '上个月赢家',
    no1: 'No1',
    no2: 'No2',
    no3: 'No3',
    no45: 'No4,No5',

    spegift: `特殊礼物*1<br/>(1个月)`,
    show: '屏幕展示*1<br/>(3天)',
    perMedal: '勋章*1<br/>(永久)',
    car: '座驾*1<br/>(1个月)',
    head: '头像框*1<br/>(1个月)',
    mMedal: '勋章*1<br/>(1个月)',
    sp: `
    永久勋章<br/>
    （连续3个月获得第一名，可获得另一枚特殊徽章）`,

    ruleContent: `

    财富榜规则：<br/>
    财富排行榜的排名取决于您每月送出的礼物为准,<br/>
    除特殊礼物外，其他奖励将在倒计时结束后自动送出.<br/><br/>
    魅力榜规则：<br/>
    魅力排行榜的排名取决于您每月收到的礼物<br/>
    除特殊礼物外，其他奖励将在倒计时结束后自动送出.<br/><br/>
    房间榜规则：<br/>
    房间列表的顺序取决于你的房间每个月收到的礼物.<br/><br/>

    备注:<br/>
    奖励一个月，意思是每个月一号发放，到下个月一号前.
    `
  },
  en: {
    rule: 'Rule',
    recharge: 'Recharge',
    glory: 'Wealth',
    charm: 'Charm',
    room: 'Room',
    rw: 'Reward',
    medalDesc: 'Medals won many times will be upgraded',
    winer: 'Winner of last month',
    no1: 'No1',
    no2: 'No2',
    no3: 'No3',
    no45: 'No4,No5',

    spegift: 'Special Gift*1<br/>(a month)',
    show: 'Screen Show*1<br/>(three days)',
    perMedal: 'Medal*1<br/>(Permanent)',
    car: 'Car*1<br/>(a month)',
    head: 'Head*1<br/>(a month)',
    mMedal: 'Medal*1<br/>(a month)',
    sp: `
    Permanent Medal
    (while winning the first place 3 consecutive months, you will get anoter special Medal)
    `,

    ruleContent: `

    Wealth list rules:<br/>
    The ranking of the wealth leaderboard depends on the gifts you send every month<br/>
    In addition to special gifts, other rewards will be sent automatically after the countdown ends<br/><br/>

    Charm List Rules:<br/>
    The ranking of the Charm Leaderboard depends on the gifts you receive each month<br/>
    In addition to special gifts, other rewards will be sent automatically after the countdown ends<br/><br/>

    Room list rules:<br/>
    The order of the room list depends on the gifts your room receives each month<br/><br/>

    Tip:<br/>
    Reward for one month, which means that it will be released on the 1st of each month until the 1st of the next month
    `
  },
  ar: {
    rule: 'القواعد',
    recharge: 'الشحن',
    glory: 'الثروة',
    charm: 'الجاذبيه',
    room: 'الغرفة',
    rw: 'مكافأة',
    medalDesc: 'احصل على الشارة عدة مرات ، ستتم ترقية الشارة',
    winer: 'الفائزون الشهر الماضي',
    no1: 'No1',
    no2: 'No2',
    no3: 'No3',
    no45: 'No4,No5',

    spegift: '(شهر واحد) هدايا مخصصة',
    show: 'إعلان في الشاشة 3 ايام',
    perMedal: 'شارة دائمة',
    car: 'دخولية شهر',
    head: 'إطار شهر',
    mMedal: 'شارة شهر',
    sp: `شارة دائمة  <br/>
    (أثناء الفوز بالمركز الاول 3 اشهر متتالية ستحصل على شارة خاصة)`,


    ruleContent: `
    قواعد قائمة الأغنياء : <br/>
     يعتمد ترتيب قائمة الاغياء على الهدايا المرسلة الشهرية بإستثاء الهدايا الخاصة سيتم ارسال المكافأت الاخرى تلقائيا بعد انتهاء العد التنازلي 
     <br/><br/>
     قواعد قائمة الجاذبية : <br/>
     يعتمد ترتيب قائمة الجاذبية على الهدايا التي تستلمها شهريا بإستثاء الهدايا الخاصة سيتم ارسال المكافأت الاخرى تلقائيا بعد انتهاء العد التنازلي <br/>
     <br/><br/>
     قواعد قائمة الغرف :<br/>
     يعتمد ترتيب قائمة الغرف على الهدايا التي <br/>
     تستلمها غرفتك شهريا <br/>
     <br/><br/>
     مكافأة لمدة شهر واحد ، مما يعني أنه سيتم إصدارها في  <br/>
     اليوم الأول من كل شهر حتى الأول من الشهر التالي  
    `
  },
  tr: {
    rule: 'kural',
    recharge: 'Şarj etmek',
    glory: 'Servet',
    charm: 'Cazibe',
    room: 'Oda',
    rw: 'Ödül',
    medalDesc: 'Birçok kez kazanılan madalyalar yükseltilecek',
    winer: 'Geçen ayın kazananı',
    no1: 'No1',
    no2: 'No2',
    no3: 'No3',
    no45: 'No4,No5',


    spegift: ' Özel Hediye*1<br/>(30 Gün)',
    show: ' Ekran Gösterisi*1<br/>(3 Gün)',
    perMedal: 'Madalya*1<br/>(Kalıcı)',
    car: 'Araç*1<br/>(30 Gün)',
    head: 'Çerçeve*1<br/>(30 Gün)',
    mMedal: ' Madalya*1<br/>(30 Gün)',
    sp: `Kalıcı Madalya (3 ay üst üste birinciliği kazandığınızda başka bir özel madalya alacaksınız)`,
    ruleContent: `Zenginlik Listesi Kuralları:<br/>
    Zenginlik sıralaması her ay gönderdiğiniz hediyelere bağlıdır. Özel hediyelerin yanı sıra diğer ödüller de geri sayım bittikten sonra otomatik olarak gönderilecektir.<br/>
    
    Cazibe Listesi Kuralları:<br/>
    Cazibe Liderlik Tablosunun sıralaması her ay aldığınız hediyelere bağlıdır<br/>
    Özel hediyelerin yanı sıra diğer ödüller de geri sayım bittikten sonra otomatik olarak gönderilecektir.<br/>
    
    Oda Listesi Kuralları:<br/>
    Oda listesinin sırası odanızın her ay aldığı hediyelere göre değişir.<br/>
    
    Not:<br/>
    30 Günlük ödül , her ayın 1'inden bir sonraki ayın 1'ine kadar geçerli olacağı anlamına gelir.
    `
  },
  jp:{
    rule: 'ルール',
    recharge: 'リチャージ',
    glory: '財産',
    charm: '魅力',
    room: '部屋',
    rw: '報酬',
    medalDesc: '何度も獲得したメダルはアップグレードされます',
    winer: '先月の勝者',
    no1: 'No1',
    no2: 'No2',
    no3: 'No3',
    no45: 'No4,No5',

    spegift: '特別な贈り物*1<br/>(1月)',
    show: 'スクリーンショー*1<br/>(3日)',
    perMedal: 'メダル*1<br/>(永続)',
    car: '車*1<br/>(1月)',
    head: '頭*1<br/>(1月)',
    mMedal: 'メダル*1<br/>(1月)',
    sp: `
    恒久メダル（3ヶ月連続1位獲得中、特別メダル1枚獲得）
    `,

    ruleContent: `

    資産リストのルール:<br/>
    ウェルス リーダーボードのランキングは、毎月贈るギフトによって異なります<br/>
    特別なプレゼントに加えて、カウントダウン終了後に他の報酬が自動的に送信されます<br/><br/>

    チャームリストのルール:<br/>
    チャームリーダーボードのランキングは、毎月受け取るギフトによって異なります<br/>
    特別なプレゼントに加えて、カウントダウン終了後に他の報酬が自動的に送信されます<br/><br/>

    ルームリストのルール:<br/>
    ルームリストの順番は、あなたのルームが毎月受け取るギフトによって異なります<br/><br/>

    例証する:<br/>
    1 か月分の報酬、つまり、毎月 1 日から翌月 1 日までリリースされます。
    `
  },
  pt:{
    rule: 'Regra',
    recharge: 'Recarga',
    glory: 'Riqueza',
    charm: 'Charme',
    room: 'Sala',
    rw: 'Recompensa',
    medalDesc: 'Medalhas ganhas muitas vezes serão atualizadas',
    winer: 'Vencedor do mês passado',
    no1: 'Número 1',
    no2: 'Número 2',
    no3: 'Número 3',
    no45: 'Número 4, Número 5',

    spegift: 'Presente Especial*1<br/>(um mês)',
    show: 'Exibição na tela*1<br/>(três dias)',
    perMedal: 'Medalha*1<br/>(Permanente)',
    car: 'Carro*1<br/>(um mês)',
    head: 'Cabeça*1<br/>(um mês)',
    mMedal: 'Medalha*1<br/>(um mês)',
    sp: `
    Medalha Permanente
    (se você ganhar o primeiro lugar por 3 meses consecutivos, receberá uma outra medalha especial)
    `,

    ruleContent: `

    Regras da lista de riqueza:<br/>
    A classificação da tabela de riqueza depende dos presentes que você envia todo mês<br/>
    Além dos presentes especiais, outras recompensas serão enviadas automaticamente após o fim da contagem regressiva<br/><br/>

    Regras da lista de charme:<br/>
    A classificação da tabela de charme depende dos presentes que você recebe todo mês<br/>
    Além dos presentes especiais, outras recompensas serão enviadas automaticamente após o fim da contagem regressiva<br/><br/>

    Regras da lista de sala:<br/>
    A ordem da lista de salas depende dos presentes que sua sala recebe todo mês<br/><br/>

    Dica:<br/>
    Recompensa de um mês, o que significa que será liberada no primeiro dia de cada mês até o primeiro dia do próximo mês
    `
  },
  id:{
    rule: 'Aturan',
    recharge: 'Isi Ulang',
    glory: 'Kekayaan',
    charm: 'Pesona',
    room: 'Kamar',
    rw: 'Hadiah',
    medalDesc: 'Medali yang dimenangkan berkali-kali akan diperbarui',
    winer: 'Pemenang bulan lalu',
    no1: 'No1',
    no2: 'No2',
    no3: 'No3',
    no45: 'No4,No5',

    spegift: 'Hadiah Khusus*1<br/>(sebulan)',
    show: 'Tampilan Layar*1<br/>(tiga hari)',
    perMedal: 'Medali*1<br/>(Seumur hidup)',
    car: 'Mobil*1<br/>(sebulan)',
    head: 'Kepala*1<br/>(sebulan)',
    mMedal: 'Medali*1<br/>(sebulan)',
    sp: `
    Medali Permanen
    (selama memenangkan tempat pertama selama 3 bulan berturut-turut, Anda akan mendapatkan Medali Khusus lainnya)
    `,

    ruleContent: `

    Aturan daftar Kekayaan:<br/>
    Peringkat papan kekayaan bergantung pada hadiah yang Anda kirim setiap bulan<br/>
    Selain hadiah khusus, hadiah lainnya akan dikirim secara otomatis setelah hitungan mundur berakhir<br/><br/>

    Aturan Daftar Pesona:<br/>
    Peringkat papan Pesona bergantung pada hadiah yang Anda terima setiap bulan<br/>
    Selain hadiah khusus, hadiah lainnya akan dikirim secara otomatis setelah hitungan mundur berakhir<br/><br/>

    Aturan Daftar Kamar:<br/>
    Urutan daftar kamar bergantung pada hadiah yang diterima kamar Anda setiap bulan<br/><br/>

    Tip:<br/>
    Hadiah untuk satu bulan, yang berarti akan dirilis pada tanggal 1 setiap bulan hingga tanggal 1 bulan berikutnya
`

  },
  uz:{
    "rule": "Qoidalar",
    "recharge": "To'ldirish",
    "glory": "Boylik",
    "charm": "Joziba",
    "room": "Xona",
    "rw": "Mukofot",
    "medalDesc": "Ko'plab yutilgan medallar yangilanadi",
    "winer": "O'tgan oyning g'olibi",
    "no1": "1-o'rin",
    "no2": "2-o'rin",
    "no3": "3-o'rin",
    "no45": "4,5-o'rin",

    "spegift": "Maxsus sovg'a*1<br/>(bir oy)",
    "show": "Ekran ko'rsatuvi*1<br/>(uch kun)",
    "perMedal": "Medal*1<br/>(Doimiy)",
    "car": "Avtomobil*1<br/>(bir oy)",
    "head": "Bosh*1<br/>(bir oy)",
    "mMedal": "Medal*1<br/>(bir oy)",
    "sp": `
    Doimiy Medal
    (agar uch oy ketma-ket birinchi o'rinni yutsangiz, yana bir maxsus medal olasiz)
    `,

    "ruleContent": `

    Boylik ro'yxati qoidalari:<br/>
    Boylik reytingi har oy yuborgan sovg'alariga asoslanadi<br/>
    Maxsus sovg'alar tashqari, boshqa mukofotlar hisoblash tugagandan so'ng avtomatik tarzda yuboriladi<br/><br/>

    Joziba ro'yxati qoidalari:<br/>
    Joziba reytingi har oy olgan sovg'alariga asoslanadi<br/>
    Maxsus sovg'alar tashqari, boshqa mukofotlar hisoblash tugagandan so'ng avtomatik tarzda yuboriladi<br/><br/>

    Xona ro'yxati qoidalari:<br/>
    Xona ro'yxati tartibi har oy xonangiz olgan sovg'alariga asoslanadi<br/><br/>

    Eslatma:<br/>
    Bir oylik mukofot, ya'ni har oyning 1-kunidan keyingi oyning 1-kunigacha chiqariladi
    `
},
    ru:{
    "rule": "Правило",
    "recharge": "Пополнение",
    "glory": "Богатство",
    "charm": "Очарование",
    "room": "Комната",
    "rw": "Награда",
    "medalDesc": "Медали, полученные много раз, будут улучшены",
    "winer": "Победитель прошлого месяца",
    "no1": "1-е место",
    "no2": "2-е место",
    "no3": "3-е место",
    "no45": "4-е, 5-е место",

    "spegift": "Особый подарок*1<br/>(на месяц)",
    "show": "Экранное шоу*1<br/>(три дня)",
    "perMedal": "Медаль*1<br/>(Постоянно)",
    "car": "Автомобиль*1<br/>(на месяц)",
    "head": "Голова*1<br/>(на месяц)",
    "mMedal": "Медаль*1<br/>(на месяц)",
    "sp": `
    Постоянная медаль
    (если вы занимаете первое место 3 месяца подряд, вы получите еще одну специальную медаль)
    `,

    "ruleContent": `
    Правила списка богатства:<br/>
    Рейтинг в списке богатства зависит от подарков, которые вы отправляете каждый месяц<br/>
    Кроме специальных подарков, другие награды будут отправлены автоматически после окончания отсчета времени<br/><br/>

    Правила списка очарования:<br/>
    Рейтинг в списке очарования зависит от подарков, которые вы получаете каждый месяц<br/>
    Кроме специальных подарков, другие награды будут отправлены автоматически после окончания отсчета времени<br/><br/>

    Правила списка комнат:<br/>
    Порядок в списке комнат зависит от подарков, которые ваша комната получает каждый месяц<br/><br/>

    Совет:<br/>
    Награда за месяц, что означает, что она будет выпущена с 1-го числа каждого месяца до 1-го числа следующего месяца
    `
},
    fa:{
    "rule": "قانون",
    "recharge": "شارژ",
    "glory": "ثروت",
    "charm": "جذابیت",
    "room": "اتاق",
    "rw": "پاداش",
    "medalDesc": "مدال‌هایی که بارها برنده شده‌اند ارتقا می‌یابند",
    "winer": "برنده ماه گذشته",
    "no1": "مقام اول",
    "no2": "مقام دوم",
    "no3": "مقام سوم",
    "no45": "مقام چهارم، پنجم",

    "spegift": "هدیه ویژه*1<br/>(یک ماه)",
    "show": "نمایش صفحه نمایش*1<br/>(سه روز)",
    "perMedal": "مدال*1<br/>(دائمی)",
    "car": "ماشین*1<br/>(یک ماه)",
    "head": "سر*1<br/>(یک ماه)",
    "mMedal": "مدال*1<br/>(یک ماه)",
    "sp": `
    مدال دائمی
    (با برنده شدن در جایگاه اول سه ماه متوالی، شما مدال ویژه دیگری دریافت خواهید کرد)
    `,

    "ruleContent": `
    قوانین لیست ثروت:<br/>
    رتبه‌بندی در لیست ثروت بستگی به هدایایی دارد که هر ماه ارسال می‌کنید<br/>
    علاوه بر هدایا ویژه، سایر پاداش‌ها پس از پایان شمارش معکوس به طور خودکار ارسال خواهند شد<br/><br/>

    قوانین لیست جذابیت:<br/>
    رتبه‌بندی در لیست جذابیت بستگی به هدایایی دارد که هر ماه دریافت می‌کنید<br/>
    علاوه بر هدایا ویژه، سایر پاداش‌ها پس از پایان شمارش معکوس به طور خودکار ارسال خواهند شد<br/><br/>

    قوانین لیست اتاق‌ها:<br/>
    ترتیب در لیست اتاق‌ها بستگی به هدایایی دارد که اتاق شما هر ماه دریافت می‌کند<br/><br/>

    نکته:<br/>
    پاداش برای یک ماه، به این معنی است که از اولین روز هر ماه تا اول ماه بعد منتشر خواهد شد
    `
}



}


// WEBPACK FOOTER //
// src/pages/activity/monthly-rank/lang.js